function getContactFormDetails(elToggle) {
  const details = elToggle.getAttribute('data-contact-form-details');
  if (details === null) {
    if (
      elToggle.getAttribute('data-contact-form-details-source') !== 'building-feature'
      && !elToggle.classList.contains('building-feature__contact-link')
    ) {
      return null;
    }

    const buildingFeature = elToggle.closest('.wp-block-acf-building-feature');
    const heading = buildingFeature?.querySelector('h3');
    const paragraph = heading?.nextElementSibling;

    if (!heading || paragraph?.tagName !== 'P') {
      return null;
    }

    return [heading.textContent, paragraph.textContent]
      .map((value) => value.trim())
      .filter(Boolean)
      .join('\n') || null;
  }

  return details;
}

function populateContactForm(elModal, elToggle) {
  const details = getContactFormDetails(elToggle);
  if (details === null) {
    return;
  }

  const detailsDisplay = elModal.querySelector('[data-contact-form-details-display]');
  if (detailsDisplay) {
    detailsDisplay.replaceChildren();

    details.split(/\r?\n/).forEach((line, index) => {
      const lineElement = document.createElement('span');
      const lineNames = ['location', 'address', 'specs'];

      lineElement.className = `contact-form-modal__details-line contact-form-modal__details-line--${lineNames[index] || 'extra'}`;
      lineElement.textContent = line;
      detailsDisplay.append(lineElement);
    });
  }

  const contactTarget = elModal.querySelector('.contact-target textarea, textarea.contact-target');
  if (!contactTarget) {
    return;
  }

  contactTarget.value = details;
  contactTarget.dispatchEvent(new Event('input', {bubbles: true}));
}

function initFloatingLabels(elModal) {
  const fields = elModal.querySelectorAll('.gfield:not(.contact-target)');

  [...fields].forEach((field) => {
    if (field.dataset.floatingLabelsInitialized === 'true') {
      return;
    }

    const control = field.querySelector(
      'input:not([type="radio"]):not([type="checkbox"]), textarea'
    );
    if (!control) {
      return;
    }

    const syncValueState = () => {
      field.classList.toggle('gfield--has-value', control.value.trim() !== '');
    };

    field.dataset.floatingLabelsInitialized = 'true';
    syncValueState();
    control.addEventListener('input', syncValueState);
    control.addEventListener('change', syncValueState);
  });
}

function syncBodyScrollLock() {
  document.body.classList.toggle('modal-open', document.querySelector('.modal--open') !== null);
}

function syncContactFormTitle(elModal) {
  const title = elModal.querySelector('.contact-form-modal__title');
  if (!title) {
    return;
  }

  const confirmation = elModal.querySelector(
    '.gform_confirmation_wrapper, .gform_confirmation_message'
  );
  title.classList.toggle('contact-form-modal__title--hidden', confirmation !== null);
}

function toggleModal(el, event) {
  const name = el.getAttribute('data-modal-toggle')
    || (el.classList.contains('building-feature__contact-link') ? 'contact-form' : null);
  if (!name) {
    return;
  }

  const elModal = document.querySelector(`[data-modal=${name}]`);
  if (!elModal) {
    return;
  }

  if (!el.getAttribute('data-modal-toggle')) {
    event.preventDefault();
  }

  populateContactForm(elModal, el);
  elModal.classList.toggle('modal--open');
  syncBodyScrollLock();
}

function closeOpenModals() {
  const open = document.querySelectorAll('.modal--open');
  if (open.length === 0) {
    return;
  }

  [...open].forEach((elModal) => elModal.classList.remove('modal--open'));
  syncBodyScrollLock();
}

function init() {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOpenModals();
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-modal-toggle], .building-feature__contact-link')
      : null;
    if (target) {
      toggleModal(target, event);
    }
  });

  const modals = document.querySelectorAll('.modal');
  [...modals].forEach((elModal) => {
    initFloatingLabels(elModal);
    syncContactFormTitle(elModal);

    const observer = new MutationObserver(() => {
      initFloatingLabels(elModal);
      syncContactFormTitle(elModal);
    });
    observer.observe(elModal, {childList: true, subtree: true});
  });
}

export default {init};
